/** Frontend symbol catalog — IDs must match backend symbolId values */
export interface SlotSymbolOption {
  id: number;
  name: string;
  emoji: string;
}

export const SLOT_SYMBOL_CATALOG: SlotSymbolOption[] = [
  { id: 1, name: "Cherry", emoji: "🍒" },
  { id: 2, name: "Lemon", emoji: "🍋" },
  { id: 3, name: "Diamond", emoji: "💎" },
  { id: 4, name: "Star", emoji: "⭐" },
  { id: 5, name: "Gift", emoji: "🎁" },
  { id: 6, name: "Seven", emoji: "7️⃣" },
];

export function getSlotSymbolById(symbolId: number): SlotSymbolOption {
  return (
    SLOT_SYMBOL_CATALOG.find((s) => s.id === symbolId) || {
      id: symbolId,
      name: `Symbol #${symbolId}`,
      emoji: "❓",
    }
  );
}
